import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MyRangeInput from '../MyRangeInput'
import FeedbackBox from '../contact/FeedbackBox'
import {feedbackString} from './HelpStrings'

export default function HelpFeedback(props){
      return (
        <span>
              {feedbackString}
              <div className={"pt-3"}>
                <FeedbackBox/>
              </div>
        </span>);
}
